import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Box } from '@mui/material'

import { ColorBoxContent, ColorBoxHeader } from '../../common/ui/colorBox'

/**
 * Documents the changes in the feature set through parsing Markdown files, and leverages on the ReactMarkdown package to generate static pages for feature additions and changes
 * @returns {React.ReactElement}
 */
export default function Changelog() {
  const [posts, setPosts] = useState([])

  // For post content
  const importAllPosts = (r) => r.keys().map(r)
  const markdownFiles = importAllPosts(
    require.context('./ChangeLogArchives', false, /\.md$/)
  )
    .sort()
    .reverse()

  useEffect(() => {
    const getPosts = async () => {
      await Promise.all(
        markdownFiles.map((file) => {
          return fetch(file).then((res) => res.text())
        })
      )
        .then((res) => setPosts(res))
        .catch((err) => console.error(err))
    }
    getPosts()
  }, [])

  return (
    <>
      <ColorBoxHeader>Changelog 💡</ColorBoxHeader>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px'
        }}
      />
      <ColorBoxContent style={{ marginBottom: 8 }}>
        <h3>
          Updates, fixes and improvements to&nbsp;
          <a href='/app' style={{ color: '#9F2B68' }}>
            ORBIT
          </a>
          .
        </h3>
        <div data-cy='markdown'>
          {posts.map((post, idx) => (
            <div
              style={{
                width: '100%',
                margin: '30px auto 80px auto',
                padding: '10px 20px 20px 20px',
                overflow: 'hidden',
                backgroundColor: '#FFFFFF',
                minHeight: '200px',
                boxSizing: 'border-box',
                boxShadow:
                  '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
              }}
              key={idx}
            >
              <ReactMarkdown
                components={{
                  img: ({ ...props }) => (
                    <img
                      style={{
                        width: '80%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                      {...props}
                    />
                  ),
                  h1: ({ ...props }) => (
                    <h1 style={{ color: 'purple' }} {...props} />
                  ),
                  h3: ({ ...props }) => (
                    <h3 style={{ color: 'purple' }} {...props} />
                  ),
                  blockquote: ({ ...props }) => (
                    <blockquote
                      style={{
                        color: '#666',
                        margin: '0',
                        paddingLeft: '3em',
                        borderLeft: '0.5em #eee solid'
                      }}
                      {...props}
                    />
                  )
                }}
              >
                {post}
              </ReactMarkdown>
              <br />
            </div>
          ))}
        </div>
      </ColorBoxContent>
    </>
  )
}
